import SmoothscrollPolyfill from 'smoothscroll-polyfill';
// import 'intersection-observer';
// import 'picturefill';
import 'what-input';
// import focusVisible from 'focus-visible';

import {SmoothScrollVanilla} from "../modules/SmoothScrollVanilla";
// import {ScrollAnimationTrigger} from "../modules/ScrollAnimationTrigger";
import {SwitchNavState} from "../modules/SwitchNavState";

import {observeHeightVars} from "../modules/observeHeightVars";
import {WebAnimationsApiAccordion} from '../modules/WebAnimationsApiAccordion'
import {initVideoPlayer} from '../modules/initVideoPlayer'
import {initExpandContent} from '../modules/initExpandContent'
import {initMoreContent} from '../modules/initMoreContent'

//import {SwitchAccordionState} from "../modules/SwitchAccordionState";
// import {SwitchTabState} from "../modules/SwitchTabState";
//import {headerFixed} from "../modules/headerFixed";
//import {scrollCv} from "../modules/scrollCv";
//import {DragScrollContents} from "../modules/DragScrollContents";

import {splide} from "../modules/splide";
import {SwitchModalState} from '../modules/SwitchModalState'

//import {swiper} from "../modules/swiper";
//import {instagram} from "../modules/instagram";

SmoothscrollPolyfill.polyfill();

SmoothScrollVanilla();
// ScrollAnimationTrigger();
SwitchNavState();

observeHeightVars()
WebAnimationsApiAccordion()
initVideoPlayer();
initExpandContent();
initMoreContent();
SwitchModalState();

// SwitchAccordionState();
// SwitchTabState();
//headerFixed();
//scrollCv();
// DragScrollContents();

splide();
// swiper();
// instagram();
